// src/app/pages/press/press.component.ts

import { Component, OnInit } from '@angular/core';

import { CommonModule } from '@angular/common';

import { RouterModule } from '@angular/router';

import { SeoService } from '../../services/seo.service';

@Component({
  selector: 'app-press',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './press.component.html',
  styleUrls: ['./press.component.css'],
})
export class PressComponent implements OnInit {

  private readonly baseUrl =
    'https://www.lydialynnchristensen.com';

  private readonly pressPageId =
    `${this.baseUrl}/press#press`;

  constructor(private seo: SeoService) {}

  ngOnInit(): void {
    this.seo.update(
      'Press Kit',
      'Media resources, press contact, bios, and downloadable assets for journalists covering Lydia Christensen\'s Libertarian Michigan Senate campaign.',
      'press'
    );

    this.seo.setStructuredData({
      "@context": "https://schema.org",
      "@type": "WebPage",
      "@id": this.pressPageId,
      "url": `${this.baseUrl}/press`,
      "name": "Press Kit",
      "description": "Media resources, press contact, bios, and downloadable assets for journalists covering Lydia Christensen's campaign.",
      "isPartOf": {
        "@id": this.seo.websiteId
      },
      "about": {
        "@id": this.seo.lydiaId
      },
      "publisher": {
        "@id": this.seo.campaignId
      },
      "inLanguage": "en-US"
    });
  }
}